import React from 'react';
import { drop } from 'lodash';
import ArticleListBox from './ArticleListBox.jsx';
import FeaturedItem from './FeaturedItem.jsx';
import RowWithTwo from './RowWithTwo.jsx';
import InsiderAd from '../Ads/InsiderAd.jsx';
const embanner = require(`../../../assets/Euro_2020_link_Website_Banners.png`);

const TripleNewsBox = ({articles, country}) => (

    <ArticleListBox articles={drop(articles, 9)} >
     	<FeaturedItem contentContainer={articles[0]} country={country} />
        <RowWithTwo articles={[articles[1], articles[2]]} className="featured-news" />
        
        <FeaturedItem contentContainer={articles[3]} country={country} />
        <RowWithTwo articles={[articles[4], articles[5]]} className="featured-news"/>
        <FeaturedItem contentContainer={articles[6]} country={country} />
        <RowWithTwo articles={[articles[7], articles[8]]} className="featured-news"/>

    </ArticleListBox>
);

export default TripleNewsBox;



// WEBPACK FOOTER //
// ./src/component/NewsFeed/TripleNewsBox.jsx